import React  , { Component } from 'react'
import LazyLoad from 'react-lazyload';
import { animateScroll as scroll } from 'react-scroll'
import {  HomeSlider,
          HomeDeals,
          VideoSliderItem,
          PostSliderItem,
          HomeTitle,
          ResponsiveYouTubeIframe,
          ImgAndText    } from '../../Components/UI/UI'

import {  newPosts } from "../../Data/Data";
import { getWeather , foundInString, getUrl} from "../../Utility/Utility";
import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'
import SimpleSlider from '../../Components/SimpleSlider/SimpleSlider';
import "../innerPage.css"
import "./SitesOfSignificance.css"

// private class data 

 const PageObj1 = {
    img : 'Jerusalem.jpg' ,
    img_mob : 'Jerusalem-mob.jpg' ,
    link : '/Pages/JerusalemPage',
    text : 'JERUSALEM'
  }

  const PageObj2 = {
    img : 'Galilee.jpg' ,
    img_mob : 'Galilee-mob.jpg' ,
    link : '/Pages/GalileePage',
    text : 'GALILEE'
  }

  const PageObj3 = {
    img : 'CoastalPlain.jpg' ,
    img_mob : 'CoastalPlainPage-mob.jpg' ,
    link : '/Pages/CoastalPlainPage',
    text : 'COASTAL PLAIN'
  }

  const PageObj4 = {
    img : 'ValleyDesert.jpg' ,
    img_mob : 'ValleyDesert-mob.jpg' ,
    link : '/Pages/ValleyDesertPage',
    text : 'JORDAN VALLEY & JUDEAN DESERT'
  }


class SitesOfSignificance extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

    telAvivVideo: "XDei1Zy_cu4",
    telAvivVideoState : 0,
    jerusalemVideo : "k4OwoEk5wMw",
    jerusalemVideoState:0,
    deadSeaVideo : "DzEJxjnC_UQ",
    deadSeaVideoState:0,


  }

  componentDidMount () {

    getWeather((Weather)=>{
    
      this.setState({
        telAvivWeather : Weather.telAvivWeather,
        waterTemp : Weather.water_temp,
        jerusalemWeather : Weather.jerusalemWeather,
      })

      
    });
    

     
  }
 


   


  render(){
     
    
   return(


      <div className="inner-page align-center page-whereToGo page-sitesofsignificance">
        <Menu />
        <div className="relative">
          <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} coverImg="HomeSlider/1.jpg" coverImgMobile="HomeSlider/M/1.jpg"/>
        </div>
      
          <section  className="home-section home-section-padding weather-section" id="expore-tel-aviv">
            <div className="container ac-flex ac-flex-column">
               <HomeTitle>
                SITES OF SIGNIFICANCE
                </HomeTitle>
              <div class="ac-row ac-flex ac-flex-row ac-flex-row-mob">
                <div className="ac-inner-50 ac-margin-right">
                 <ImgAndText img={PageObj1.img}  img_mob={PageObj1.img_mob} cssClass={" col-100"} link={PageObj1.link} text={PageObj1.text} />
                  <a class="show_more button" href={ getUrl() + 'Pages/JerusalemPage'}>
                     Read More >>
                  </a>
                </div>
                <div className="ac-inner-50">
                 <ImgAndText img={PageObj2.img} img_mob={PageObj2.img_mob} cssClass={" col-100"} link={PageObj2.link} text={PageObj2.text} />
                 <a class="show_more button" href={ getUrl() + 'Pages/GalileePage'}>
                     Read More >>
                  </a>
                </div>
              </div>
              <div class="ac-row ac-flex ac-flex-row ac-flex-row-mob">
                <div className="ac-inner-50 ac-margin-right">
                 <ImgAndText img={PageObj3.img}  img_mob={PageObj3.img_mob} cssClass={" col-100"} link={PageObj3.link} text={PageObj3.text} />
                  <a class="show_more button" href={ getUrl() + 'Pages/CoastalPlainPage'}>
                     Read More >>
                  </a>
                </div>
                <div className="ac-inner-50">
                 <ImgAndText img={PageObj4.img} img_mob={PageObj4.img_mob} cssClass={" col-100"} link={PageObj4.link} text={PageObj4.text} />
                 <a class="show_more button" href={ getUrl() + 'Pages/ValleyDesertPage'}>
                     Read More >>
                  </a>
                </div>
              </div>
              
              <div className="clear"></div>
            </div>
          </section>
    

        <Footer />
      </div>
    )
  }

}



export default SitesOfSignificance


// WEBPACK FOOTER //
// ./src/Pages/SitesOfSignificance/SitesOfSignificance.js